import { Button, Canvas, TextField, Form, FieldGroup } from 'datocms-react-ui';
import { Form as FormHandler, Field } from 'react-final-form';
import { ConfigScreenProps, ConfigScreenValidParams } from '../types';

type Parameters = ConfigScreenValidParams & { submitting: boolean, dirty: boolean };

export default function ConfigScreen({ ctx }: ConfigScreenProps) {
  return (
    <Canvas ctx={ctx}>
      <FormHandler<Parameters>
        initialValues={ctx.plugin.attributes.parameters}
        
        validate={(values: ConfigScreenValidParams) => {
          const errors: Record<string, string> = {};
          
          // Ensure the BmsTripJsonFieldName is not empty
          if (!values.BmsTripJsonFieldName) {
            errors.BmsTripJsonFieldName = 'This field is required!';
          }

          // Ensure the BmsTripJsonFieldName is not empty
          if (/^\d+$/.test(values.BmsTripJsonFieldName)) {
            errors.BmsTripJsonFieldName = 'Field name cannot be only numbers!';
          }

          return errors;
        }}
        
        onSubmit={async (values: ConfigScreenValidParams) => {
          await ctx.updatePluginParameters(values); 
          ctx.notice('Settings updated successfully!');
        }}
      >
        {({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <FieldGroup>
              <Field name="BmsTripJsonFieldName">
                {({ input, meta: { error } }) => (
                  <TextField
                    id="BmsTripJsonFieldName"
                    label="Trip JSON field name"
                    hint="Enter the name of the field where the JSON for trips is stored"
                    placeholder="e.g. preview"
                    required
                    error={error} 
                    {...input} 
                  />
                )}
              </Field>
            </FieldGroup>
            
            <Button type="submit" fullWidth buttonSize="l" buttonType="primary">
              Save settings
            </Button>
          </Form>
        )}
      </FormHandler>
    </Canvas>
  );
}
